import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { ConsoleLayout } from '@/components/layout/ConsoleLayout';
import { LoginPage } from '@/pages/LoginPage';
import { DashboardPage } from '@/pages/DashboardPage';
import { FeatureFlagsPage } from '@/pages/FeatureFlagsPage';
import { UsersLayout } from '@/pages/UsersLayout';
import { UsersPage } from '@/pages/UsersPage';
import { ApprovalsPage } from '@/pages/ApprovalsPage';
import { RejectedAccountsPage } from '@/pages/RejectedAccountsPage';
import { RestaurantsPage } from '@/pages/RestaurantsPage';
import { PlansPage } from '@/pages/PlansPage';
import { ReprocessPage } from '@/pages/ReprocessPage';

function RequireAdmin({ children }: { children: React.ReactNode }) {
  const { user } = useAuth();
  // `user` in the console AuthContext is now exclusively an AdminUser (the
  // post-refactor `adminLogin` mutation is the only path that populates it).
  // Presence alone proves admin identity — the prior `role !== 'ADMIN'` gate
  // was a defense against tenant tokens leaking into the console flow, which
  // is now impossible because the tenant `login` mutation rejects admin
  // emails (they no longer live in UserModel).
  if (!user) return <Navigate to="/login" replace />;
  return <>{children}</>;
}

export function AppRoutes() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route
          element={
            <RequireAdmin>
              <ConsoleLayout />
            </RequireAdmin>
          }
        >
          <Route index element={<DashboardPage />} />
          <Route path="usuarios" element={<UsersLayout />}>
            <Route index element={<UsersPage />} />
            <Route path="aprovacoes" element={<ApprovalsPage />} />
            <Route path="rejeitadas" element={<RejectedAccountsPage />} />
          </Route>
          <Route path="restaurantes" element={<RestaurantsPage />} />
          <Route path="funcionalidades" element={<FeatureFlagsPage />} />
          <Route path="planos" element={<PlansPage />} />
          <Route path="reprocessar" element={<ReprocessPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
